import { Injectable } from '@angular/core';

import { UnsavedChangesService } from '../services';

@Injectable()
export class FormActivateGuard {
	public constructor(private unsavedChangesService: UnsavedChangesService) {}

	public canActivate(): boolean {
		this.unsavedChangesService.setHasChanges(false);
		return true;
	}
}
